export const removeSubnetMappingModalState = {
	removeSubnetMappingModal: false,
	mouseHover: false,
	isLoading: false,
	isError: false,
	errorMessage: null,
	requestData: null
}

export const removeSubnetMappingModalReducer = (state, action) => {
	switch (action.type) {
		case "OPEN_REMOVE_SUBNET_MAPPING_MODAL": {
			return {
				...state,
				removeSubnetMappingModal: true,
				isLoading: false,
				isError: false,
				mouseHover: -1
			}
		}
		case "CLOSE_REMOVE_SUBNET_MAPPING_MODAL": {
			return {
				...state,
				removeSubnetMappingModal: false,
				isLoading: false,
				isError: false,
				mouseHover: -1
			}
		}
		case "SET_MOUSE_HOVER": {
			return {
				...state,
				mouseHover: action.payload
			}
		}
		case "SET_REQUEST_DATA": {
			return {
				...state,
				requestData: action.payload
			}
		}
		case "IS_LOADING": {
			return {
				...state,
				isLoading: true,
				isError: false
			}
		}
		case "REMOVE_SUBNET_MAPPING_ERROR": {
			return {
				...state,
				isLoading: false,
				isError: true,
				errorMessage: action.payload
			}
		}
		case "REMOVE_SUBNET_MAPPING_SUCCESS": {
			return {
				...state,
				isLoading: false,
				isError: false,
				removeSubnetMappingModal: false
			}
		}
		default:
			return state
	}
}